import { useState } from "react"
import { useTranslation } from "react-i18next"

import InvitationTab from "@/app/settings/club/components/invitation/invitationTab/InvitationTab"
import TabPlayerDevice from "@/app/settings/club/players/TabPlayerDevice"
import { AccountTypeKey } from "@/constants/account"
import Tab from "@/components/tab/Tab"

import "./playersAndDevices.scss"

export default function PlayersAndDevicesPage() {
  const { t } = useTranslation("")
  const tabList = [
    {
      label: t("joined"),
      value: "joined",
    },
    {
      label: t("invite"),
      value: "invitation",
    },
  ]

  const [value, setValue] = useState<string | number>(tabList[0].value)

  return (
    <div className="PlayersAndDevicesPageCont">
      <Tab
        type="filled"
        list={tabList}
        value={value}
        onChange={(_, newValue: string | number) => setValue(newValue)}
      />
      {value === tabList[0].value && (
        <div role="tabpanel">
          <TabPlayerDevice />
        </div>
      )}
      {value === tabList[1].value && (
        <div role="tabpanel">
          <InvitationTab type={AccountTypeKey.Player} />
        </div>
      )}
    </div>
  )
}
